exports.UI = {
  Region: require("./ui/region"),
  Cursor: require("./ui/cursor")
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/leapjs/lib/ui.js
 ** module id = 41
 ** module chunks = 0
 **/